module.exports = __webpack_public_path__ + "img/five.45cf0793.png";